import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  message: any;
  button: any;
  heading: boolean;
  heading_text: string | undefined;
  title: string;
  hideClose: boolean;
  autoClose: boolean;  // true = auto close on action, false = manual close
}
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ConfirmationComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
    if (this.data.autoClose) {
      setTimeout(() => {
        // this.dialogRef.close(1);
      }, 5000);
    }
  }


  onClear() {
    this.dialogRef.close(); // emit 'clear' when user clicks the clear button
  }


  closeDialog(returndata: any) {

    this.dialogRef.close(returndata);
  }
}
